/**
 * @module interface
 */
import type { V2TimUserInfo } from './v2TimUserInfo';

export interface V2TIMGetMessageReactionUserListResult {
    userList: V2TimUserInfo[];
    nextSeq?: number;
    isFinished?: boolean;
}
